import { Base64 } from 'js-base64';

export const generateClassroomViewerPayload = (assignment, userId, teachers, students, isTerminationTracked) => {
    let payload = {
        assignmentId: assignment.id,
        googleCourseWorkId: assignment.googleCourseWorkId,
        bookId: assignment.bookInfo ? assignment.bookInfo.bookId : -1,
        originalId: assignment.homeworkId,
        source: assignment.source,
        profile: assignment.profile,
        isPreview: false,
        saveStatus: true,
        isTerminationTracked: isTerminationTracked,
    };

    if (teachers.some((teacher) => teacher.userId === userId)) {
        payload.saveStatus = false;
        return Base64.encode(JSON.stringify(payload));
    }
    if (students.some((student) => student.userId === userId)) {
        return Base64.encode(JSON.stringify(payload));
    }

    return null;
};
